import { render, staticRenderFns } from "./FormBienVendu.vue?vue&type=template&id=6904ac2b&"
import script from "./FormBienVendu.vue?vue&type=script&lang=js&"
export * from "./FormBienVendu.vue?vue&type=script&lang=js&"
import style0 from "./FormBienVendu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports